import { Util } from '@shared/utils/utils';
import { OnDestroy, inject, Component } from '@angular/core';
import { environment } from '@environments/environment';
import { Subscription, Subject, takeUntil } from 'rxjs';
import { LocalRepository } from '@shared/helper/local-repository';
import { SnackbarService } from '@shared/utils/snackbar.service';
import { UserStateService } from '@app/state/user-state.service';
import { User } from '@shared/model/user-context/user.model';
import { AppStateService } from '@app/state/app-state.service';

@Component({
  template: ''
})
export abstract class BaseComponent implements OnDestroy {

  environment = environment;
  subscriptions: Subscription[] = new Array<Subscription>();
  unsubscribe$ = new Subject<void>();
  utilFunctions: Util = inject(Util);
  Repository = inject(LocalRepository);
  protected snackbarService: SnackbarService = inject(SnackbarService);
  protected userStateService = inject(UserStateService);
  protected appStateService = inject(AppStateService);
  protected currentUser: User | null = null;


  constructor() {
    this.userStateService.userData.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(d => this.currentUser = d);
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.forEach(elem => {
        elem.unsubscribe();
      });
    }
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}